export const api_config = {
    url: "https://gumisped.hu/control/bg/api/",
    endpoints : {
        config: "config",
        events: "events",
        opening_hours: "opening_hours",
        services: "services"
    }
};